const NO_SUB_MODAL_CONFIG =
{
    title: 'Upgrade Your Subscription',
    subtitle: 'Unfortunately, your current LionDesk subscription does not support texting.',
    body: `<span>
    <div>Unlock the power of texting by upgrading your subscription!</div>
    <div>Visit the Payments & Subscriptions section to select your texting plan.</div>
    </span>`,
    cta: 'Upgrade Subscription',
}

const NO_NUMBER_MODAL_CONFIG =
{
    title: 'Get Your Custom Number',
    subtitle: 'You need a custom number to text in LionDesk.',
    body: `<span>
    <div>Good news - your subscription includes a free custom number!</div>
    <div>Click below to get a number in your area code.</div>
    <div>Once you have it, you can start the registration process to validate and activate it.</div>
    </span>`,
    cta: 'Get Custom Number',
}

const NO_REG_MODAL_CONFIG =
{
    title: 'Register Your Custom Number',
    subtitle: 'Unfortunately, you can’t text until your custom number is registered.',
    body: `<span>
    <div>US mobile carriers only allow texting from registered custom numbers.</div>
    <div>The good news is that it’s simple to start and complete!</div>
    <div>Click below to begin your registration on the Texting Console.</div>
    </span>`,
    cta: 'Start Registration',
}

const REG_MODAL_CONFIG =
{
    title: 'Your Texting Registration Is In Process',
    subtitle: 'Texting will be enabled once your registration is complete.',
    body: `<span>
    <div>US mobile carriers only allow texting from fully registered custom numbers.</div>
    <div>The good news is your registration is being processed!</div>
    <div>Click below to check your status on the Texting Console.</div>
    </span>`,
    cta: 'Check Registration Status',
}

const DEFAULT_MODAL_CONFIG =
{
    title: '',
    subtitle: '',
    body: '',
    cta: '',
}

export { NO_SUB_MODAL_CONFIG, NO_NUMBER_MODAL_CONFIG, NO_REG_MODAL_CONFIG, REG_MODAL_CONFIG, DEFAULT_MODAL_CONFIG }
